var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.25 35.833"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3767"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.871 12.341a1.251 1.251 0 01.168 2.489l-.168.011H1.393a1.251 1.251 0 01-.168-2.489l.168-.011z",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.487 18.85a1.251 1.251 0 01.168 2.489l-.168.011a1.251 1.251 0 01-.184-2.489zM16.148 18.85a1.251 1.251 0 01.168 2.489l-.168.011a1.251 1.251 0 01-.184-2.489zM8.794 18.85a1.251 1.251 0 01.168 2.489l-.184.011a1.251 1.251 0 01-.168-2.489zM23.487 25.327a1.251 1.251 0 01.168 2.489l-.168.011a1.251 1.251 0 01-.184-2.489zM16.148 25.327a1.251 1.251 0 01.168 2.489l-.168.011a1.251 1.251 0 01-.184-2.489zM8.794 25.327a1.251 1.251 0 01.168 2.489l-.184.011a1.251 1.251 0 01-.168-2.489zM22.812 0a1.244 1.244 0 011.229 1.08l.011.17v5.485a1.24 1.24 0 01-2.469.165l-.011-.165V1.25A1.245 1.245 0 0122.812 0zM9.452 0a1.244 1.244 0 011.229 1.08l.011.17v5.485a1.24 1.24 0 01-2.469.165l-.011-.165V1.25A1.245 1.245 0 019.452 0z",
    fill: "#a28d50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.118 35.832H9.132a9.213 9.213 0 01-6.674-2.426A9.184 9.184 0 010 26.703V11.62a8.962 8.962 0 012.457-6.6 9.3 9.3 0 016.675-2.388h14a9.254 9.254 0 016.741 2.447 8.968 8.968 0 012.377 6.541v15.212a8.99 8.99 0 01-2.45 6.612 9.292 9.292 0 01-6.682 2.388zM9.132 5.132c-4.29 0-6.652 2.3-6.652 6.488v15.083c0 4.276 2.362 6.631 6.652 6.631h13.986c4.288 0 6.65-2.31 6.65-6.5V11.617a6.47 6.47 0 00-1.651-4.773 6.768 6.768 0 00-4.982-1.712z",
    fill: "#7e7e7e"
  }))));
}

export default SvgNavbarCalendar;